import LoginBaseModel from "./login-base-model";
import Routing        from "../app/router";

class LoginOtpModel extends LoginBaseModel
{
    resendOtpCode()
    {
        return new Promise((resolve, reject) => {
            const url = Routing.generate('session_mfa_resend_hotp');
            $.ajax({
                       url,
                   }).then(resolve, reject);
        });
    }
}
export default LoginOtpModel;